module.exports = __webpack_public_path__ + "static/media/place-2.d5534083.jpg";